export default __webpack_public_path__ + "media/images/btnlogin2-0c6a21e801e6fb9040406959707ad1e3.png";